import React from 'react';
import HeroSection from '../../../components/ProductsDetail/HeroSection';
import ProductShowcaseSection from '../../../components/ProductsDetail/ProductShowcaseSection';
import CTASection from '../../../components/ProductsDetail/CTASection';
import {
  InfoSection,
  TypeBlock,
  UsageSteps,
  FeatureList,
} from '../../../components/ProductsDetail/InfoBlocks';
import SectionDivider from '../../../components/ProductsDetail/SectionDivider';
import ProductDetailNav from '../../../components/ProductsDetail/ProductDetailNav';


const SafetyStairs = () => {
  
  /* ------------------------
   * 제품 유형 데이터
   * (이미지 경로는 보유 파일명으로 교체 가능)
   * ------------------------ */
  const typeGroups = [
    {
      title: '3W 기본형',
      items: [
        { src: '/images/products/guardrail/version2/3W-basic.jpg',     label: '' },
        { src: '/images/products/guardrail/version2/3W-basic2.jpg',     label: '' },
        { src: '/images/products/guardrail/version2/3W-basic3.jpg',     label: '' },
        // { src: '/images/products/guardrail/3W-basic-sliding.webp', label: '슬라이딩형' },
        // { src: '/images/products/guardrail/3W-basic-rotate.webp',  label: '회전형' },
         // 파일 없으면 나중에 교체/삭제
      ],
    },
    {
      title: '3W 확장형',
      items: [
        { src: '/images/products/guardrail/version2/3W-extend.jpg',    label: '' },
        { src: '/images/products/guardrail/version2/3W-extend2.jpg',    label: '' },
        { src: '/images/products/guardrail/version2/3W-extend3.jpg',    label: '' },
        // { src: '/images/products/guardrail/3W-extend-sliding.webp', label: '슬라이딩형' },
        // { src: '/images/products/guardrail/3W-extend-rotate.webp',  label: '회전형' },
        
      ],
    },
    {
      title: '개방형 2단',
      items: [
        // { src: '/images/products/guardrail/2W-open1.webp', label: '' },
        { src: '/images/products/guardrail/version2/2W-open.jpg', label: '' },
        { src: '/images/products/guardrail/version2/2W-open2.jpg', label: '' },
        { src: '/images/products/guardrail/version2/2W-open3.jpg', label: '' },
      ],
    },
    {
      title: '개방형 3단',
      items: [
        // { src: '/images/products/guardrail/3W-open1.webp', label: '' },
        { src: '/images/products/guardrail/version2/3W-open.jpg', label: '' },
        { src: '/images/products/guardrail/version2/3W-open2.jpg', label: '' },
        { src: '/images/products/guardrail/version2/3W-open3.jpg', label: '' },
      ],
    },
    {
      title: '안전계단 + 고객 대피소',
      items: [
        { src: '/images/products/guardrail/version2/road-shelter1.jpg', label: '' },
        { src: '/images/products/guardrail/version2/road-shelter2.jpg', label: '' },
      ],
    },
  ];

  /* ------------------------
   * 사용 방법 스텝
   * (이미지 경로 자유 교체)
   * ------------------------ */
  const steps = [
    {
      image: '/images/products/guardrail/step1.webp',
      text: '1. 안전발판의 레일을 슬라이딩 방식으로 잡아당깁니다.',
    },
    {
      image: '/images/products/guardrail/step2.webp',
      text: '2. 안내표지판이 장착된 안전손잡이를 잡고 발판을 밟고 안전하게 이동합니다.',
    },
    {
      image: '/images/products/guardrail/step3.webp',
      text: '3. 작업 완료 후 가드레일 밖으로 안전하게 이동합니다.',
    },
    {
      image: '/images/products/guardrail/step4.webp',
      text: '4. 안전발판을 원위치로 밀어 넣어 차량 통행에 방해가 되지 않도록 합니다.',
    },
  ];

  const features = [
    {
      title: '안전한 오르내림을 위한 안정적인 발판 구조',
      bullets: [
      {
        label: (
          <>견고한 발판이 가드레일을 넘어가는 과정에서 지지력을 확보하여 추락·미끄럼 사고 방지</>
        ),
      },
      {
        label: (
          <>내·외측 어느 방향에서도 안정적인 이동이 가능해 다양한 현장 환경에 대응</>
        ),
      },
      {
        label: (
          <>작업자의 신체 부담 감소 및 반복 작업 시 안전성 향상</>
        ),
      },
      ]
    },
    {
      title: '손잡이 봉 설치로 중심 상실 사고 예방',
      bullets: [
      {
        label: (
          <>안전계단 상부에 <strong>잡을 수 있는 손잡이 봉을 추가 설치</strong>하여 오르내림 시 중심을 잃어 넘어지는 사고를 사전에 차단</>
        ),
      },
      {
        label: (
          <>비·눈 등 미끄러운 환경에서도 안정적인 이동 보조</>
        ),
      },
      {
        label: (
          <>초보 작업자나 갑작스러운 대피 상황에서도 안전성 강화</>
        ),
      },
      ]
    },
    {
      title: '고객대피소(대피 공간) 제공으로 추가 안전 확보',
      bullets: [

      {
        label: (
          <>가드레일 밖으로 나간 이후에도 도로 이용자가 <strong>더 안전한 위치로 대기할 수 있도록 설계된 대피소 구조 포함</strong></>
        ),
      },
      {
        label: (
          <>사고 대기자 및 작업자의 2차 위험을 최소화하는 안전 존 확보</>
        ),
      },
      {
        label: (
          <>긴급 대피·사고 처리 상황에서 추가적인 생명 보호 기능 수행</>
        ),
      },
      ]
    },
    {
      title: '레일 기반 슬라이딩 & 회동 구조로 높은 설치 효율성',
      bullets: [
      {
        label: (
          <>발판의 양측 하부에는 <strong>도로 내측·외측으로 슬라이딩 이동 및 회동이 가능한 레일 구조 적용</strong></>
        ),
      },
      {
        label: (
          <>사용 시에는 신속히 펼치고, 보관 시에는 간편히 접어 공간 활용성 향상</>
        ),
      },
      {
        label: (
          <>가드레일 레일 개수나 형태에 <strong>제약 없이 설치가 가능</strong>해 다양한 현장에 유연하게 대응</>
        ),
      },
      {
        label: (
          <>시공 편의성, 유지 효율성, 현장 적용성을 모두 개선한 구조</>
        ),
      },
      ]
    },
    {
      title: '비상 상황에서 신속한 대피 유도',
      bullets: [
      {
        label: (
          <>사고 차량 운전자 및 작업자가 가드레일을 안전하게 넘어가도록 도와 <strong>2차 사고 위험을 크게 감소</strong></>
        ),
      },
      {
        label: (
          <>직관적인 구조로 긴급 상황에서도 빠르고 혼란 없이 탈출 가능</>
        ),
      },
      {
        label: (
          <>야간·악천후 상황에서도 안전한 이동으로 대피 효율 상승</>
        ),
      },
      ]
    },
    {
      title: '도로 유지보수 전 과정에서 안정성과 편의성 제공',
      bullets: [
      {
        label: (
          <>정기 점검, 시설물 보수, 사고 처리 등 <strong>모든 작업 상황에 적용 가능</strong></>
        ),
      },
      {
        label: (
          <>작업자의 이동 동선이 개선되어 작업 효율성 향상</>
        ),
      },
      {
        label: (
          <>고내구성 재질과 안전 중심 설계로 장기간 안정적 사용 가능</>
        ),
      },
      ]
    },
  ];

  return (
    <>
      <HeroSection
        title={`디딤-Safe`}
        subtitle={`비상상황 발생 시 안전한 통행과 대피를 돕습니다`}
        backgroundImage="/images/products/guardrail/road-shelter3.webp"
        breadcrumbs={[
          { label: '홈', path: '/' },
          { label: '도로 안전유도시설', path: '/products/guardrail' },
          { label: '디딤-safe' },
        ]}
        categories={[
          { label: '도로 안전경보시스템', path: '/products/traffic-safety' },
          { label: '도로 안전유도시설', path: '/products/guardrail' },
          { label: '도로환경 개선시설', path: '/products/facilities' },
          { label: '도로 안내표지시스템', path: '/products/signage' },
        ]}
      />

      <ProductShowcaseSection
        subtitle={`가드레일용 안전발판`}
        title={`디딤-Safe`}
        description={
          <>
            도로의 내·외측에서 시설물 점검, 유지보수 작업을 수행하거나, {' '}
            차량 사고 및 돌발 상황 발생 시 <strong>작업자와 운전자가 가드레일을 쉽고 안전하게 넘어갈 수 있도록 설계된 발판형 안전 구조물</strong>입니다.
            <br />
            <br />
            단순한 보조 장비를 넘어, 사고·고장·긴급 상황 발생 시 {' '}
            운전자와 작업자가 <strong>보다 쉽고 빠르게 가드레일을 넘어 안전지대로 대피할 수 있도록 돕는 구조</strong>로 설계되어, {' '}
            현장의 안전성과 효율성을 크게 향상시킵니다.
          </>
        }
        images={[
          '/images/products/guardrail/3W-basic-sliding.webp',
          '/images/products/guardrail/3W-basic-rotate.webp',
          '/images/products/guardrail/3W-extend-sliding.webp',
          '/images/products/guardrail/3W-extend-rotate.webp',
          '/images/products/guardrail/2W-open1.webp',
          '/images/products/guardrail/3W-open1.webp',
          '/images/products/guardrail/road-shelter1.webp',
        ]}
        badgeImages={[
          '/images/logo/venture.webp',
          '/images/logo/koreaRoad.webp',
        ]}
        
      />

      {/* 구분선 */}
      <SectionDivider />

      {/* Info Section – 제품 유형 */}
      <InfoSection title="제품 유형">
        <TypeBlock groups={typeGroups} />
      </InfoSection>

      {/* Info Section – 사용방법 */}
      <InfoSection title="사용방법">
        <UsageSteps steps={steps} />
      </InfoSection>

      <InfoSection title="제품 특징">
        <FeatureList features={features} />
      </InfoSection>

      <ProductDetailNav
        category="guardrail"
        currentPath="/products/guardrail/safety-stairs"
        listPath="/products/guardrail"
      />

      <CTASection />
    </>
  );
};

export default SafetyStairs;
